import { render, staticRenderFns } from "./EmployeeDocuments.vue?vue&type=template&id=d932484e&scoped=true"
import script from "./EmployeeDocuments.vue?vue&type=script&lang=js"
export * from "./EmployeeDocuments.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDocuments.vue?vue&type=style&index=0&id=d932484e&prod&scoped=true&lang=css"
import style1 from "vue-slim-tabs/themes/default.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d932484e",
  null
  
)

export default component.exports